import React from "react";
import {Drawer} from "antd";
import {setLoginPage, setMenuOpen, setShowHistory, setShowMembership} from "../useAppPullState";
import packageJson from "../../package.json"
import {useDrawer} from "../hooks/useDrawer";
import {useLogout} from "./hooks/useLogout";

const DrawerCustom = () => {
    const {
        authUser, open,
        showHistory,
    } = useDrawer()
    const logout = useLogout();
    return (
        <>
            <Drawer
                styles={{
                    mask: {
                        opacity: 0.4,
                    }
                }}
                title={
                    authUser
                        ? authUser.userName
                            ? `${authUser?.userName?.slice(0, 15)}${authUser?.userName.length > 15 && "..."}`
                            : authUser?.firstName + " " + authUser?.LastName
                        : "Suomen Golfseniorit"
                }
                placement='right'
                onClose={() => {
                    setMenuOpen(false);
                }}
                open={open}
                width={250}
                style={{backgroundImage: "linear-gradient(to bottom, #003B7E , #0D6EFF)", color: "white"}}
            >
                {authUser == null && (
                    <a
                        onClick={() => {
                            setLoginPage(true);
                            setMenuOpen(false);
                        }}
                        className='menu-item'
                    >
                        Kirjaudu sisään
                    </a>
                )}
                {/* <a className='header-link' onClick={() => setIsOpen(true)}>
          Log in
        </a> */}
                {authUser != null && (
                    <>
                        <a
                            onClick={logout}
                            className='menu-item'
                        >
                            Kirjaudu ulos
                        </a>
                        {!showHistory && (
                            <>
                                <br/>

                                <a
                                    onClick={() => {
                                        setShowHistory(true)
                                        setMenuOpen(false);
                                    }}
                                    className='menu-item'
                                >
                                    Varaushistoria
                                </a>
                            </>
                        )}
                        {showHistory && authUser != null && (
                            <>
                                <br/>
                                <a
                                    onClick={() => {
                                        setShowHistory(false);
                                        setMenuOpen(false);
                                    }}
                                    className='menu-item'
                                >
                                    Golf kentät
                                </a>
                            </>
                        )}
                        {authUser != null && (
                            <>
                                <br/>
                                <a
                                    onClick={() => {
                                        setShowMembership(true)
                                        setMenuOpen(false);
                                    }}
                                    className='menu-item'
                                >
                                    Jäsenkortti
                                </a>
                            </>
                        )}
                    </>
                )}
                <p style={{position: "absolute", bottom: 0}}>Version: {packageJson.version}</p>
            </Drawer>
        </>
    );
};
export default DrawerCustom;
